export function getLanguagePart(locale: string): string {
    const matches = locale.match(/^[^-]+/);
    if (matches === undefined || matches === null || matches.length === 0) return "en";
    return matches[0];
}
